import { isValidString } from '@nykaa/utils/validations';
import { scaleImageInUri } from '@nykaa/utils/image';
import { FORMAT, SCALE } from './constants';
import { getAbsoluteSize, getImgQueryString, isValidMimeType, oldScaleImage, } from './helpers';
export const getRawUrl = (url) => {
    if (!isValidString(url))
        return '';
    const noQueryUrl = url.split('?')[0];
    return noQueryUrl === null || noQueryUrl === void 0 ? void 0 : noQueryUrl.replace(FORMAT, '');
};
export const scaleImage = ({ url, width: cWidth, height: cHeight, trim, cropStrategy, isAbsoluteSize, }) => {
    const newUrl = getRawUrl(url);
    if (!isValidMimeType(newUrl)) {
        return {
            src: newUrl,
            srcSet: '',
        };
    }
    const { width, height, } = getAbsoluteSize(cWidth, cHeight, isAbsoluteSize);
    const src = `${newUrl}${getImgQueryString({
        cropStrategy, width, height, trim,
    })}`;
    const srcSet = `${src} 1x, ${newUrl}${getImgQueryString({
        cropStrategy, width, height, trim, scale: SCALE,
    })} ${SCALE}x`;
    return {
        src,
        srcSet,
    };
};
export const getOptimisedImageUrl = ({ url, width, height, cropStrategy, newImageUrlEnabled, requiredScaleSize, }) => {
    if (!url) {
        return {
            src: '',
            srcSet: '',
        };
    }
    if (newImageUrlEnabled) {
        return scaleImage({
            url, width, height, cropStrategy,
        });
    }
    const imageParams = Object.assign({ width, height, url }, (url.match(FORMAT) ? {} : { cropStrategy }));
    const scaleImageFunc = url.match(FORMAT) ? scaleImageInUri : oldScaleImage;
    const src = scaleImageFunc(imageParams);
    let srcSet = '';
    if (requiredScaleSize) {
        const scaleImageParams = Object.assign(Object.assign(Object.assign({}, imageParams), { width: imageParams.width * requiredScaleSize }), ((imageParams === null || imageParams === void 0 ? void 0 : imageParams.height) && { height: imageParams.height * requiredScaleSize }));
        const scaledSrc = scaleImageFunc(scaleImageParams);
        srcSet = `${src} 1x, ${scaledSrc} ${requiredScaleSize}x`;
    }
    return { src, srcSet };
};
